var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow_down_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M1.717 10.131a.691.691 0 0 0 .005.005l5.594 5.602a.872.872 0 0 0 .147.117l.16.088.11.036h.081c.123.023.25.023.373 0H8.348l.125-.066a.888.888 0 0 0 .19-.139l5.616-5.637a.96.96 0 0 0 .005-1.357l-.005-.005a.981.981 0 0 0-1.355 0l-3.346 3.338a.366.366 0 0 1-.622-.256V.955a.96.96 0 1 0-1.918 0v10.902a.366.366 0 0 1-.622.256L3.084 8.775a.981.981 0 0 0-1.362 0 .96.96 0 0 0-.005 1.356Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_down_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 16H0V0h16z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export default ForwardRef;